import { PATH_APP } from "src/routes/paths";

/**
 * Ruta a la que volver tras una acción que "cierra" o "aparta" el foco
 * de la operativa actual (pagar, cerrar sesión, reabrir ticket, back
 * desde la carta, etc.):
 *
 *   - Modo mesas normal:  vuelve al plano de mesas.
 *   - Modo solo-TPV:      vuelve al propio TPV camarero, que trabaja
 *                         sobre una "mesa virtual" única y persistente.
 *                         El plano de mesas no aplica porque no hay
 *                         mesas físicas configuradas.
 *
 * Centralizarlo evita que cada `history.push(PATH_APP.tuCarta.tpv)`
 * disperso tenga que replicar la comprobación del flag `isOnlyTpv`.
 * Sitios que NO usen este helper y sigan yendo directo al plano de
 * mesas romperán la experiencia en modo TPV (mesas vacío / mesa virtual
 * mal seleccionada).
 */
export function postActionRoute(user) {
  return user?.isOnlyTpv
    ? PATH_APP.tpv.cartaCamarero
    : PATH_APP.tuCarta.tpv;
}
